import { useSteamVideoSafety } from "../contexts/SteamVideoSafetyContext";
import { shouldHideSteamVideo } from "../utils/steamVideoSafety";

export default function SteamVideoPreview({ children, tags, style, className }) {
  const { showNsfwVideos } = useSteamVideoSafety();
  if (shouldHideSteamVideo(tags, showNsfwVideos)) return null;
  return <div className={className} style={style}>{children}</div>;
}
